module.exports = __webpack_public_path__ + "media/images/payments/ingenico-dark-1a0a0dcdfa761a13d5e91d6cbf3fb600.svg";